export type GetRootComponentsRequest = {
  withCpntPjtStatusFlag?: string;
};
